import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgCheck = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  width: 20,
  height: 20,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.39 14.74 3 10.35l1.34-1.34L8 12.67 16.66 4 18 5.34l-9.39 9.39c-.17.17-.39.26-.61.26s-.44-.1-.61-.26Z"
}));
export default SvgCheck;